import {
  SecretField,
  ShownOnceWarning,
} from '../../../components/shown-once-secret';

type ServiceAccountSecretRevealProps = {
  clientId: string;
  clientSecret: string;
};

export const ServiceAccountSecretReveal = ({
  clientId,
  clientSecret,
}: ServiceAccountSecretRevealProps) => {
  return (
    <div className="flex flex-col gap-4">
      <ShownOnceWarning title="This secret is shown only once.">
        Copy it now and store it in a secret manager — you will not be able to
        see it again, only rotate it.
      </ShownOnceWarning>

      <SecretField
        label="Client ID"
        value={clientId}
        toastMessage="Client ID copied"
      />
      <SecretField
        label="Client secret"
        value={clientSecret}
        toastMessage="Client secret copied"
      />
    </div>
  );
};
